import { defineModule } from '@core/modules';
import { ModulePath, ModuleTitle } from '@common/types';
import DocumentsInbox from './containers';

export default defineModule({
  title: ModuleTitle.DocumentsInbox,
  path: ModulePath.DocumentsInbox,
  component: DocumentsInbox
});
